import { AnnualReportingDetails } from './../../models/manageWorkflow.model';
import {
  ApproveWorkflowModel,
  ManageWorkflowService,
} from './../../../modules/manage-workflows/services/manage-workflow.service';
import { CoreService } from './../../../core/services/core.service';
import { WorkflowTableGridHeader } from './workflow-table-grid.model';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import {
  NOT_READY_ASX_CONSENT_PUBLISH_TOOLTIP,
  NOT_READY_USSEC_CONSENT_PUBLISH_TOOLTIP,
  NOT_READY_WORKFLOW_TOOLTIP,
  PRE_REQUISITE_ASSIGNEE,
  START_WORKFLOW_TOOLTIP,
} from '../../constants/messages';
import {
  ASX_UPLOAD_AND_CONSENT,
  US_SEC_UPLOAD_AND_CONSENT,
  WORKFLOW_LAST_UPDATE_BY,
  WORKFLOW_LAST_UPDATE_ON,
} from '../../constants/constant';
import { convertUTCDateToLocalDateMMDDYYYYHHMMSS } from 'src/app/shared/utilities/util';
import { DataCaptureService } from 'src/app/modules/data-capture/services/data-capture.service';

@Component({
  selector: 'app-workflow-table-grid',
  templateUrl: './workflow-table-grid.component.html',
  styleUrls: ['./workflow-table-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowTableGridComponent implements OnInit {
  @Input() headers: WorkflowTableGridHeader[];
  @Input() data: Array<any>;
  @Input() showrecord: boolean;
  @Input() searchText?: string;
  @Input() noRecordTxt = 'No record found.';
  @Input() enableCPQPNomination = false;
  @Input() startAllWorkflowName: string;
  @Input() showCountAllWorkflowButton = false;
  @Input() isCPQPUser = false;
  @Input() isConsentToPublishAdminView = false;
  @Input() showActions = false;
  @Input() adminLanding = false;
  @Input() isReportingCycleLocked = false;
  @Input() disableUpdateProfile = false;
  @Input() isCpQpNomination = false;
  @Input() checkboxDisable = false;
  @Input() disableConsentLink = false;
  @Input() allWorkflowSelectionBtnTxt: string;
  @Output() onRowSelect = new EventEmitter();
  @Output() onDelete = new EventEmitter();
  @Output() onEdit = new EventEmitter();
  @Output() onDownload = new EventEmitter();
  @Output() onLockUnlock = new EventEmitter();
  @Output() onLink = new EventEmitter();
  @Output() onReset = new EventEmitter();
  @Output() onRestart = new EventEmitter();
  @Output() onUpdate = new EventEmitter();
  @Output() onUnlock = new EventEmitter();
  @Output() onViewLogHistory = new EventEmitter();
  @Output() onCpQpReport = new EventEmitter();
  @Output() onPrinterProof = new EventEmitter();
  @Output() onStartWorkflow = new EventEmitter();
  @Output() onSelectStartAllReadyWorkflows = new EventEmitter();
  @Output() onCheckWorkflow = new EventEmitter();
  @Output() onViewNomination = new EventEmitter();
  @Output() onReject = new EventEmitter();
  @Output() onApprove = new EventEmitter();
  @Output() onEndorse = new EventEmitter();
  @Output() onEndorse3Endorse = new EventEmitter();
  @Output() onEndorse3Reject = new EventEmitter();
  @Output() onEndorse4Endorse = new EventEmitter();
  @Output() onEndorse4Reject = new EventEmitter();
  @Output() onExport = new EventEmitter();
  @Output() onImport = new EventEmitter();
  @Output() onAcknowledge = new EventEmitter();
  @Output() onConsentEvent = new EventEmitter();
  @Output() refreshData = new EventEmitter();
  @Output() onApproveAllWorkflows = new EventEmitter();
  @Output() consentOnBehalfEvent = new EventEmitter();
  cloneData: Array<any>;
  public defaultSort: WorkflowTableGridHeader;
  public shormoreClicked = false;
  public disableNotReadyWorkflows = true;
  public loggedInUserID: number;
  public checkSelectAll = false;
  public showApproveAllWorkflows = false;
  public showCheckFieldForEndorser1 = false;
  public showCheckFieldForEndorser2 = false;
  public disableEndorser1CheckAll = false;
  public disableEndorser2CheckAll = false;
  public notReadyWorkflowTooltip = NOT_READY_WORKFLOW_TOOLTIP;
  public ReadyWorkflowTooltip = START_WORKFLOW_TOOLTIP;
  public notReadyAsxConsentTooltip = NOT_READY_ASX_CONSENT_PUBLISH_TOOLTIP;
  public notReadyUssecConsentTooltip = NOT_READY_USSEC_CONSENT_PUBLISH_TOOLTIP;
  public preRequisiteTooltip = PRE_REQUISITE_ASSIGNEE;
  public reportingCycleLockedDate: any;
  public reportingCycleLockedMessage: string;
  public uploadConsentASX = ASX_UPLOAD_AND_CONSENT;
  public uploadConsentUSSEC = US_SEC_UPLOAD_AND_CONSENT;
  public isUserRoleConsumer = false;
  isAdmin: boolean;
  isConsumer: boolean;

  constructor(
    private coreService: CoreService,
    private ref: ChangeDetectorRef,
    private manageWorkflowService: ManageWorkflowService,
    private dataCaptureService: DataCaptureService
  ) {
    this.loggedInUserID = this.coreService.getLoggedInID();
    this.isAdmin = this.coreService.isAdmin;
    this.isConsumer = this.coreService.isConsumer;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.disableEndorser1CheckAll = true;
    this.disableEndorser2CheckAll = true;
    this.isReportingCycleLocked =
      sessionStorage.getItem('isCurrentReportingCycleYearLock') === '1';
    this.reportingCycleLockedDate = sessionStorage.getItem(
      'CurrentReportingCycleYearLockDate'
    );
    //new DatePipePipe().transform()
    this.reportingCycleLockedMessage =
      'The current Reporting Cycle has been locked on ' +
      convertUTCDateToLocalDateMMDDYYYYHHMMSS(this.reportingCycleLockedDate) +
      '. Please unlock the Reporting Cycle in Manage Reporting Cycle to perform any actions on this workflow.';
    if (changes && changes.headers && changes.headers.currentValue) {
      this.headers.forEach((element) => {
        if (!element.sort) {
          element.sort = 'none';
        } else {
          this.defaultSort = element;
        }
      });
    }

    if (changes && changes.data && changes.data.currentValue) {
      this.manageWorkflowService.updateWorkflowStatus(this.data);
      const workflowStatusZeroIndex = this.data.findIndex(
        (element) => element.workflowStatus === '0'
      );
      if (workflowStatusZeroIndex > -1) {
        this.disableNotReadyWorkflows = false;
      }
      this.data.forEach((element) => {
        element['checked'] = false;
        if (
          this.headers[0] &&
          this.headers[0].type === 'nomination-multiple-workflow-check'
        ) {
          if (
            element.workflowStatus === '3' ||
            element.workflowStatus === '5'
          ) {
            this.showCheckFieldForEndorser1 = true;
            if (element.wfLevel3UserID == this.loggedInUserID) {
              this.disableEndorser1CheckAll = false;
            }
          }
        }
        if (
          this.headers[0] &&
          this.headers[0].type === 'multiple-workflow-check'
        ) {
          if (
            element.workflowStatus === '3' ||
            element.workflowStatus === '5' ||
            element.workflowStatus === '4' ||
            element.workflowStatus === '6'
          ) {
            this.showCheckFieldForEndorser2 = true;
            if (
              ((element.workflowStatus === '3' ||
                element.workflowStatus === '5') &&
                element.wfLevel3UserID == this.loggedInUserID) ||
              ((element.workflowStatus === '4' ||
                element.workflowStatus === '6') &&
                element.wfLevel4UserID == this.loggedInUserID)
            ) {
              this.disableEndorser2CheckAll = false;
            }
          }
        }
      });
      this.cloneData = JSON.parse(JSON.stringify(this.data));
      this.sortTableData();
    }
  }

  public sortTableData(): void {
    const index =
      this.headers &&
      this.headers.findIndex((x: WorkflowTableGridHeader) => x.sort !== 'none');
    if (index > -1) {
      if (this.headers[index].sort === 'none') {
        this.setDefaultState();
      } else if (this.headers[index].sort === 'desc') {
        this.sortInDescOrder(this.headers[index]);
      } else if (this.headers[index].sort === 'asc') {
        this.sortInAscOrder(this.headers[index]);
      }
    }
  }

  ngOnInit(): void {
    this.isUserRoleConsumer = this.dataCaptureService.getConsumerRoleType();
  }

  onSelect(item) {
    this.onRowSelect.emit(item);
  }

  sortData(header) {
    if (header.sort === 'none') {
      header.sort = 'desc';
      this.sortInDescOrder(header);
    } else if (header.sort === 'desc') {
      header.sort = 'asc';
      this.sortInAscOrder(header);
    } else if (header.sort === 'asc') {
      header.sort = 'none';
      this.setDefaultState();
    }

    this.headers.forEach((element) => {
      if (header.name !== element.name) {
        element.sort = 'none';
      }
    });
  }

  sortInAscOrder(header) {
    this.data.sort((a, b) => {
      let item1;
      let item2;
      if (header.sortType === 'string') {
        // Use toUpperCase() to ignore character casing
        item1 = a[header.key] ? a[header.key].toUpperCase() : '';
        item2 = b[header.key] ? b[header.key].toUpperCase() : '';
      } else if (header.sortType === 'number') {
        item1 = a[header.key] ? Number(a[header.key]) : 0;
        item2 = b[header.key] ? Number(b[header.key]) : 0;
      } else if (header.sortType === 'date') {
        item1 = a[header.key] ? new Date(a[header.key]).getTime() : '';
        item2 = b[header.key] ? new Date(b[header.key]).getTime() : '';
      } else if (header.sortType === 'boolean') {
        item1 = a[header.key] === '1' ? 'checked' : 'unchecked';
        item2 = b[header.key] === '1' ? 'checked' : 'unchecked';
      }
      if (item1 > item2) {
        return -1;
      } else if (item1 < item2) {
        return 1;
      }
      return 0;
    });
  }

  sortInDescOrder(header) {
    this.data.sort((a, b) => {
      // Use toUpperCase() to ignore character casing
      let item1;
      let item2;
      if (header.sortType === 'string') {
        // Use toUpperCase() to ignore character casing
        item1 = a[header.key] ? a[header.key].toUpperCase() : '';
        item2 = b[header.key] ? b[header.key].toUpperCase() : '';
      } else if (header.sortType === 'number') {
        item1 = a[header.key] ? Number(a[header.key]) : 0;
        item2 = b[header.key] ? Number(b[header.key]) : 0;
      } else if (header.sortType === 'date') {
        item1 = a[header.key] ? new Date(a[header.key]).getTime() : '';
        item2 = b[header.key] ? new Date(b[header.key]).getTime() : '';
      } else if (header.sortType === 'boolean') {
        item1 = a[header.key] === '1' ? 'checked' : 'unchecked';
        item2 = b[header.key] === '1' ? 'checked' : 'unchecked';
      }

      if (item1 > item2) {
        return 1;
      } else if (item1 < item2) {
        return -1;
      }
      return 0;
    });
  }

  setDefaultState() {
    this.data = JSON.parse(JSON.stringify(this.cloneData));
  }

  edit(item) {
    this.onEdit.emit(item);
  }

  delete(item) {
    this.onDelete.emit(item);
  }

  download(item) {
    this.onDownload.emit(item);
  }

  lockUnlock(item) {
    this.onLockUnlock.emit(item);
  }

  public showMore(item): void {
    item.shormoreClicked = true;
    item.moreAssignee = item.assignee;
  }
  public link(item): void {
    sessionStorage.removeItem(WORKFLOW_LAST_UPDATE_BY);
    sessionStorage.removeItem(WORKFLOW_LAST_UPDATE_ON);
    setTimeout(() => {
      sessionStorage.setItem(WORKFLOW_LAST_UPDATE_BY, item.updatedBy);
      sessionStorage.setItem(WORKFLOW_LAST_UPDATE_ON, item.updatedOn);
    }, 200);
    this.onLink.emit(item);
  }
  public reset(item): void {
    this.onReset.emit(item);
  }
  public restart(item): void {
    this.onRestart.emit(item);
  }
  public update(item): void {
    this.onUpdate.emit(item);
  }
  public unlock(item): void {
    this.onUnlock.emit(item);
  }

  public viewLogHistory(item): void {
    this.onViewLogHistory.emit(item);
  }

  public onSelectStartWorkflow(item): void {
    this.onStartWorkflow.emit(item);
  }

  public onSelectStartAllWorkflows(data: AnnualReportingDetails[]): void {
    const workflowdata = data.filter((x) => x.workflowStatus === '0');
    this.manageWorkflowService.updateSessionStorage(workflowdata);
    this.onSelectStartAllReadyWorkflows.emit(workflowdata);
  }

  public onCheck(event, item, fieldSelected): void {
    const workflow = {
      checked: event.target.checked,
      data: item,
      key: fieldSelected,
      component: this,
    };
    this.onCheckWorkflow.emit(workflow);
  }

  public viewNomination(item): void {
    this.onViewNomination.emit(item);
  }

  public printerProof(item): void {
    this.onPrinterProof.emit(item);
  }

  /**
   * onApproveEvent
   * Approve by ORC
   */
  public onORCApproveEvent(item: AnnualReportingDetails): void {
    this.onApprove.emit(item);
  }

  /**
   * name
   * Rejected by ORC
   */
  public onORCRejectEvent(item): void {
    this.onReject.emit(item);
  }

  /**
   * onEndorseEvent
   */
  public onEndorseEvent(item): void {
    this.onEndorse.emit(item);
  }

  /**
   * onEndorser3EndorserEvent
   */
  public onEndorser3EndorserEvent(item) {
    this.onEndorse3Endorse.emit(item);
  }

  /**
   * onEndorser3RejectEvent
   */
  public onEndorser3RejectEvent(item) {
    this.onEndorse3Reject.emit(item);
  }

  /**
   * onEndorser4EndorserEvent
   */
  public onEndorser4EndorserEvent(item) {
    this.onEndorse4Endorse.emit(item);
  }

  /**
   * onEndorser4RejectEvent
   */
  public onEndorser4RejectEvent(item) {
    this.onEndorse4Reject.emit(item);
  }

  public export(item): void {
    this.onExport.emit(item);
  }

  public import(item): void {
    this.onImport.emit(item);
  }
  /**
   * selectWorkflow
   */
  public selectWorkflow() { }

  /**
   * acknowledge
   */
  public acknowledge(item): void {
    this.onAcknowledge.emit(item);
  }

  /**
   * cpQpReport
   */
  public cpQpReport(item): void {
    this.onCpQpReport.emit(item);
  }

  /**
   * onConsent
   */
  public onConsent(item): void {
    this.onConsentEvent.emit(item);
  }

  public onMultiWorkflowSelection(event, selectedItem): void {
    this.showApproveAllWorkflows = false;
    selectedItem.checked = event.target.checked;
    this.data.forEach((element) => {
      if (element.checked) {
        this.showApproveAllWorkflows = true;
      } else {
        this.checkSelectAll = false;
      }
    });
  }

  public onSelectAllReportingWorkflows(event, data): void {
    this.showApproveAllWorkflows = false;
    if (event.target.checked) {      
      this.checkSelectAll = true;
    }
    data.forEach((element) => {
      if (
        ((element.workflowStatus === '3' || (element.workflowType != '2' && element.workflowStatus === '5')) &&
          element.wfLevel3UserID == this.loggedInUserID) ||
        ((element.workflowStatus === '4' || element.workflowStatus === '6') &&
          element.wfLevel4UserID == this.loggedInUserID)
      ) {
        element.checked = event.target.checked;
        this.showApproveAllWorkflows = true;
      }
    });
  }

  public onSelectAllNominationWorkflows(event, data): void {
    this.showApproveAllWorkflows = false;
    if (event.target.checked) {
      this.showApproveAllWorkflows = true;
      this.checkSelectAll = true;
    }
    data.forEach((element) => {
      if (element.workflowStatus === '3' || element.workflowStatus === '5') {
        element.checked = event.target.checked;
      }
    });
  }

  public onApproveAllWorkflowsEvent(data): void {
    const workflowData = [];
    data.forEach((item) => {
      if (item.checked) {
        workflowData.push(item);
      }
    });
    this.onApproveAllWorkflows.emit(workflowData);
  }

  public rerenderComponent(): void {
    setInterval(() => {
      this.ref.detectChanges();
    }, 500);
  }

  public consentOnBehalf(item): void {
    this.consentOnBehalfEvent.emit(item);
  }
}
